/* global menuPagesMobileJson, menuPagesDesktopJson, regionChoicesJson, requestResourcesPageJson */

function renderMenuButton() {
  var content = {
    menuItemsMobile: menuPagesMobileJson,
    menuItemsDesktop: menuPagesDesktopJson,
    regionChoices: regionChoicesJson,
    requestResource: requestResourcesPageJson,
  };

  var mobileMenu = document.getElementById("lod-menu");
  if (typeof window.renderMobileMenu == "function" && mobileMenu) {
    window.renderMobileMenu(mobileMenu, content);
  }

  var desktopMenu = document.getElementById("lod-menu-desktop");
  if (typeof window.renderDesktopMenu == "function" && desktopMenu) {
    window.renderDesktopMenu(desktopMenu, content);
  }

  const searchBar = document.getElementById("lod-menu-search-bar");
  if (typeof window.renderSearchBar == "function" && searchBar) {
    window.renderSearchBar(searchBar, content);
  }
}

function hideMenuBarOnScrollDown() {
  var headerId = "pinned-header";
  var headerHeightPx = 145;
  var regionBanner = document.getElementById("region-banner");
  var prevScrollpos = window.pageYOffset;

  if (regionBanner && regionBanner.style.display == "block") {
    headerHeightPx *= 2;
  }

  //  Hide header on scroll down
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    if (
      prevScrollpos > currentScrollPos ||
      currentScrollPos <= headerHeightPx ||
      document.getElementsByClassName("modal-container").length >= 1
    ) {
      document.getElementById(headerId).style.top = "0";
    } else {
      document.getElementById(headerId).style.top =
        "-" + headerHeightPx.toString() + "px";
    }
    prevScrollpos = currentScrollPos;
  };
}

document.addEventListener("DOMContentLoaded", function () {
  renderMenuButton();
  hideMenuBarOnScrollDown();
});
